module.exports = {
  response_failed: 'Deine Antwort konnte nicht erstellt werden. Bitte stelle die Frage erneut.',
  ai_generated_warning: 'Diese Antwort wurde von einer KI generiert. Überprüfe KI-Inhalte immer mit vertrauenswürdigen Informationsquellen.',
  appointments: 'Termine',
  ask_button: 'Fragen',
  ask_community: 'Community fragen',
  all_done_title: 'Super, du hast alle Aufgaben erledigt!',
  ask_community_button: 'Ja, Community fragen',
  ask_community_error: 'Fehler beim Laden der Community-Daten',
  ask_community_loading: 'Lade Community-Daten...',
  ask_community_prompt: 'Möchten Sie diese Frage in der Community stellen?',
  citation: {
    title: 'Zitat',
    view_file: 'Datei öffnen',
  },
  cover_image_course_alt: 'Kurs-Cover-Bild',
  cover_image_news_alt: 'News-Cover-Bild',
  create_post: {
    title: 'Beitrag erstellen',
    community_label: 'Community',
    content_label: 'Beitrag',
    content_placeholder: 'Was möchtest du teilen oder fragen?',
    submitting: 'Wird gepostet...',
    submit: 'Posten',
    community_required_warning: 'Bitte wähle zuerst eine Community aus.',
    you: 'Du',
  },
  debug_requests: 'Debug-Anfragen',
  ai_response_title: 'Suchergebnis',
  debug_requests_title: 'Debug-Anfragen für Community-Beitragsantworten',
  from_opponent: 'Von %{opponent}',
  go_back: 'Zurück',
  listening_placeholder: 'Ich höre zu...',
  modal_title: 'Keelearning fragen',
  my_open_tasks: 'Meine offenen Aufgaben',
  new_image_alt: 'Neues Bild',
  new_quiz_image_alt: 'Neues Quizbild',
  news: 'News',
  available_communities: 'Verfügbare Communities',
  available_videos: 'Verfügbare Videos',
  community_updates: 'Community-Updates',
  whats_new: 'Neuigkeiten',
  home_navigation: {
    label: 'Startseitenbereiche',
    dashboard: 'Dashboard',
    feed: 'Feed',
  },
  community_update_filters: {
    all: 'Alle',
    today: 'Heute',
    this_week: 'Diese Woche',
    this_month: 'Dieser Monat',
  },
  new_community_posts: 'Neue Community-Beiträge',
  new_files: 'Neue Dateien',
  new_news: 'Neue News',
  no_results_answer: 'Zu deiner Frage wurden keine Ergebnisse gefunden. Du kannst allgemeiner fragen oder einige Stichwörter zu deiner Frage hinzufügen.',
  open_modal: 'Dialog öffnen',
  pending_courses: 'Ausstehende Kurse',
  post_actions: 'Beitragsaktionen',
  post_created_toast: 'Beitrag erfolgreich erstellt!',
  question_placeholder: 'Stellen Sie Ihre Frage...',
  question_title: 'Deine Frage',
  quiz_battle_requests: 'Quiz Battle Anfragen',
  quiz_battles: 'Quiz Battles',
  quiz_cover_image_alt: 'Quiz-Cover-Bild',
  like_post: 'Gefällt mir',
  rate_up: 'Positiv bewerten',
  rate_down: 'Negativ bewerten',
  rating_prompt: 'War diese Antwort hilfreich?',
  related_posts: 'Verwandte Posts',
  related_media_files: 'Verwandte Mediendateien',
  start_quiz_battle: 'Quiz Battle starten',
  start_listening: 'Spracherkennung starten',
  stop_listening: 'Spracherkennung stoppen',
  unanswered_question: 'Ihre Frage wurde noch nicht beantwortet?',
  updated_image_alt: 'Aktualisiertes Bild',
  updated_quiz_image_alt: 'Aktualisiertes Quizbild',
  heroText: {
    goodMorning: 'Guten Morgen, {name}!',
    hello: 'Hallo, {name}!',
    goodEvening: 'Guten Abend, {name}!',
    midnightOil: 'Arbeitest du noch spät, {name}?',
    welcomeBack: 'Willkommen zurück, {name}!',
    readyToLearn: 'Bereit, etwas Neues zu lernen, {name}?',
    makeProductive: 'Lass uns heute produktiv sein, {name}!',
    doingGreat: 'Du machst das großartig, {name}!',
    easterEgg: {
      bananaBerry: 'Bananen sind Beeren, Erdbeeren aber nicht.',
      octopusHearts: 'Oktopusse haben drei Herzen.',
      flamboyance: 'Eine Gruppe Flamingos heißt „Flamboyance“.',
      eiffelTaller: 'Der Eiffelturm ist im Sommer bis zu 15 cm höher.',
      venusDay: 'Ein Tag auf der Venus ist länger als ein Jahr dort.',
      beeFaces: 'Honigbienen können menschliche Gesichter erkennen.',
      strawberriesAreNuts: 'Die Erdbeere ist eine Nuss.',
      bluetoothVikingKing: 'Bluetooth ist nach einem Wikingerkönig benannt.',
      atSymbolOlderThanEmail: 'Das "@"-Zeichen ist älter als E-Mails.',
    },
  },
}
